import range from 'lodash/range';

import starEmpty from '../../images/star-empty.svg';
import starFilled from '../../images/star-filled.svg';

const renderStars = (avgScore) => {
  const starImgs = range(5).map((i) => (
    i + 1 <= avgScore ? starFilled : starEmpty
  ));
  return starImgs
    .map((starImageSrc) => `<img alt="star" class="vv-exam-map__popup-star" src=${starImageSrc} width="13" height="12" />`)
    .join('');
};

export const displayDistanceFromCenter = (distance) => {
  if (distance) {
    return distance >= 1 ? ` – à\xa0${distance.toFixed(1)}\xa0km` : ` – à\xa0${(distance * 1000).toFixed(0)}\xa0m`;
  }
  return '';
};

export const getPopupContent = (properties) => {
  const {
    http_path, title, adress, zipcode, city, avg_ratings_score, ratings_count, distance_from_center,
  } = properties;

  const avgScore = Math.round(avg_ratings_score);
  const starImgs = renderStars(avgScore);

  if (!ratings_count) {
    return (
      `<div>
        <h4 class="vv-exam-map__popup-title">${title}</h4>
        <div class="vv-exam-map__popup-address">
          ${adress} ${zipcode} ${city} 
          ${displayDistanceFromCenter(distance_from_center)}
        </div>
      </div>`
    );
  }

  return (
    `<div>
        <h4 class="vv-exam-map__popup-title">${title}</h4>
        <div class="vv-exam-map__popup-address">
          ${adress} ${zipcode} ${city} 
          ${displayDistanceFromCenter(distance_from_center)}
        </div>
        <div class="vv-exam-map__popup-rating">
          ${starImgs}
          <a href="${http_path}#avis" class="vv-exam-map__popup-reviews-count" 
            target="_blank" rel="noopener noreferrer">${ratings_count} avis</a>
        </div>
      </div>`
  );
};

export const getProperIconClassName = (marker) => {
  let className = 'marker';
  const { type } = marker.properties;
  if (type) {
    className = `marker-${type.replace(/ /g, '').toLowerCase()}`;
  }
  return className;
};

export const closeOpenedPopup = () => {
  const popUp = document.querySelector('.mapboxgl-popup');
  if (popUp) {
    popUp.remove();
  }
};
